// Chakra imports
import { Text, useColorModeValue ,Flex} from "@chakra-ui/react";
// Assets
import Project1 from "assets/img/profile/Vector.png";
// Custom components
import Card from "components/card/Card.js";
import React from "react";
import Project from "views/admin/profile/components/Project";
import Upload from "views/admin/profile/components/Upload";

export default function Projects(props) {
  // Chakra Color Mode
  const textColorPrimary = useColorModeValue("secondaryGray.900", "white");
  const textColorSecondary = "gray.400";
  const cardShadow = useColorModeValue(
    "0px 18px 40px rgba(112, 144, 176, 0.12)",
    "unset"
  );
  return (
    <Card mb={{ base: "0px", "2xl": "20px" }}>
      <Flex>
      <Text
        color={textColorPrimary}
        fontWeight='bold'
        fontSize='2xl'
        mt='10px'
        mb='4px'
        w='100px'>
        All Files
      </Text>
      <Upload
          
          minH={{ base: "auto", lg: "70px", "2xl": "70px" }}
          pe='20px'
          pb={{ base: "100px", lg: "20px" }}
        />
        
      </Flex>
      
      <Project
        boxShadow={cardShadow}
        mb='20px'
        image={Project1}
        ranking='1'
        link='#'
        title='Medical Records'
      />
      <Project
        boxShadow={cardShadow}
        mb='20px'
        image={Project1}
        ranking='2'
        link='#'
        title='Health History Forms'
      />
      <Project
        boxShadow={cardShadow}
        image={Project1}
        ranking='3'
        link='#'
        title='Treatment Plans'
      />

    </Card>
  );
}
